import React, { useState, useEffect } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Loader from "../components/Loader";
import AccessRightService from "../services/AccessRightService";

const AccessRight = ({ isLoggedIn }) => {
  const accessRightService = new AccessRightService();
  const [nodes, setNodes] = useState([]);
  const [UserId, setUserId] = useState(0);
  const [formError, setFormError] = useState({ UserId: null });
  const [userddlList, setUserddlList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [checkedItems, setCheckedItems] = useState({});

  const childUncheck = (e) => {
    const { name, checked } = e.target;
    setCheckedItems({ ...checkedItems, [name]: checked });
  };

  const GetUserList = async () => {
    accessRightService.GetUsersDDL().then((res) => {
      if (res.responseCode === "200") {
        setUserddlList(res.responseData);
      } else {
        setUserddlList([]);
      }
    });
  };

  const GetAccessRight = async (id) => {
    setLoading(true);
    accessRightService.GetAccessRight(id).then((res) => {
      setLoading(false);
      if (res.responseCode === "200") {
        let data = res.responseData;
        setNodes(data);
        setTimeout(() => {
          editcheckbox(data);
        }, 1000);
      }
    });
  };

  const onCheckAll = (e) => {
    var chkValue = e.currentTarget.value;
    var className = e.currentTarget.className;
    var IsChecked = e.currentTarget.checked;
    if (className !== "") {
      var checkboxlist = document.getElementsByClassName("child" + className);
      for (var checkbox of checkboxlist) {
        checkbox.checked = IsChecked;
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    let errors = formError;
    let formIsValid = true;

    switch (name) {
      case "UserId":
        if (value === "") {
          formIsValid = false;
          errors.UserId = "Please select user.";
        } else {
          errors.UserId = "";
        }
        break;
      default:
        break;
    }

    setFormError(errors);
    setUserId(value);
  };

  const onUserChange = (e) => {
    const userId = parseInt(e.target.value);
    GetAccessRight(userId);
    handleChange(e);
  };

  const SubmitData = async () => {
    const checkboxes = document.getElementsByName("childCheck");
    let checkedValuelst = [];
    checkedValuelst.push("1");
    for (var checkbox of checkboxes) {
      if (checkbox.checked) {
        checkedValuelst.push(checkbox.value);
      }
    }

    const parentlist = nodes;
    parentlist.map((parent) => {
      let parentId = "";
      const childlst = parent.children;
      childlst.map((child) => {
        const key = child.key;
        if (checkedValuelst.indexOf(key) >= 0) {
          parentId = parent.key;
        }
      });
      if (parentId != "") {
        checkedValuelst.push(parentId);
      }
    });

    const formData = {
      UserId: UserId,
      PageList: checkedValuelst
    };
    setLoading(true);
    if (formData.UserId > 0) {
      accessRightService.CreateUpdateAccessRight(formData).then((res) => {
        setLoading(false);
        if (res !== null && res.responseCode === "200") {
          toast.success(res.responseMessage);
          GetUserList();
        } else {
          toast.error(res.responseMessage);
          GetUserList();
        }
      });
    } else {
      setLoading(false);
      let errors = formError;
      errors.UserId = "Please select user";
    }
  };

  const editcheckbox = (data) => {
    // Your logic here
    const listdata = data;
    const checkboxes = document.getElementsByName("childCheck");
    for (var checkbox of checkboxes) {
      let ischeck = false;
      listdata.map((node, i) => {
        node.children.map((childNode, k) => {
          if (checkbox.value === childNode.key && childNode.status === true) {
            ischeck = true;
          }
        });
      });
      if (ischeck) {
        checkbox.checked = ischeck;
      } else {
        checkbox.checked = false;
      }
    }
  };

  const TreeNode = nodes;
  const TreeStruture = TreeNode.map((node, i) => (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <Accordion>
          <AccordionSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>{node.data.pages}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ul className="tree-stucture"></ul>
            <ul className="tree-stucture">
              <li>
                <input type="checkbox" className={i} onChange={onCheckAll} />{" "}
                Select all
              </li>
              {node.children.map((childNode, k) => (
                <li key={childNode.key}>
                  <input
                    id={"Id" + k}
                    name="childCheck" // Use a unique name for each checkbox
                    defaultChecked={checkedItems}
                    value={childNode.key}
                    type="checkbox"
                    onChange={childUncheck}
                    className={"child" + i}
                  />
                  {childNode.data.pages}
                </li>
              ))}
            </ul>
          </AccordionDetails>
        </Accordion>
      )}
      <br />
    </div>
  ));

  // Other functions...

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
    setTimeout(() => {
      setLoading(false); // Data has loaded, set loading to false
    }, 1000);
    GetUserList();
  }, []);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="row mb-3 accesspage">
            <div className="col-md-6 heading">
              <h1>Access Right</h1>
            </div>
            <div className="col-md-2">
              <h6 className="select-user">Select User</h6>
            </div>
            <div className="col-md-4">
              <form>
                <select
                  className="form-control"
                  value={UserId}
                  onChange={onUserChange}
                  name="UserId"
                >
                  <option value="">Select User</option>
                  {userddlList.map((user) => (
                    <option key={user.value} value={user.value}>
                      {user.label}
                    </option>
                  ))}
                </select>
              </form>
            </div>
          </div>

          <span hidden={TreeStruture.length > 0 ? false : true}>
            <div className="border-box access-right">
              <h5 className="mt-3 mb-4 select-page">Select Pages</h5>
              {TreeStruture}
            </div>
            <div className="text-center mt-2 pb-3">
              <button
                type="button"
                onClick={SubmitData}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              >
                Submit
              </button>
            </div>
          </span>
        </div>
      )}
    </div>
  );
};

export default AccessRight;
